export default "/assets/images/milaair-order-bg.332bb368bca87939.jpg";